import simpleRestProvider from 'ra-data-simple-rest';
import httpClient from './httpClient';

const dataProvider = simpleRestProvider(process.env.REACT_APP_API_ENDPOINT, httpClient);
export default dataProvider;
